import { createApp } from 'vue';
import App from './App.vue';

// eslint-disable-next-line no-unused-vars
import { buildTsSmokeMessage } from './services/tsSmoke';
import router from './router';
import getUser from './services/user-info.js'

// NOTE(pspdfkit-to-bopus): bopus-pdf-reader plain Vue 3 setup.
// Vue CLI (webpack 4) does not support Vite's `?url` worker imports, so we
// serve the worker from public/ and set GlobalWorkerOptions.workerSrc.
import { setupPdfJsWorker } from './services/pdfjsWorker'
import store from './store';

import mitt from 'mitt';
import './registerServiceWorker';
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from 'highcharts/modules/solid-gauge';
import '../src/components/universal_styles.vue';
import VueHighlightJS from 'vue3-highlightjs';
import '../src/assets/highlight-js-theme.css';
import { ImagesControl } from './services/ImagesControl.js';
import Vue3TouchEvents from "vue3-touch-events";

// bopus-pdf-reader (vendored) viewer CSS.
// Loaded once here to avoid duplicating it per component instance.
import './assets/pdf-viewer-compiled.css';

fetch('/config.json').then(res => res.json()).then(async function (config) {
  console.log("config fetch completed successfully..")
  // alert(config.api);
  const emitter = mitt();

  // NOTE(pspdfkit-to-bopus): Plain Vue 3 (non-Vite) PDF.js worker setup.
  // The worker is copied into public/ (served at /pdfjs/pdf.worker.mjs).
  setupPdfJsWorker('/pdfjs/pdf.worker.mjs');

  HighchartsMore(Highcharts);
  SolidGauge(Highcharts);
  const app = createApp(App);
  app.config.globalProperties.emitter = emitter;
  app.provide('apiPath', config.api);
  app.provide('build', config.build);
  app.provide('cloudflareLink', config.cfLink);

  // NOTE(pspdfkit-to-bopus): PSPDFKit has been disabled (commented out at call
  // sites) as part of the migration to the vendored bopus-pdf-viewer.
  // We intentionally keep PSPDFKit config keys in `public/config.json` for a
  // quick rollback path, but we no longer provide/inject the PSPDFKit license
  // key into the app runtime.
  //
  // If rollback is needed:
  // - Re-enable PSPDFKit call sites
  // - Restore/adjust the verify scripts that copy PSPDFKit assets
  // - Re-enable the provide() below
  //
  // if (window.location.host.startsWith('localhost')) {
  //   app.provide('pspdfkitlkey', config.pspdfkitlkeyl);
  // } else if (window.location.host.includes('bopus.ai')) {
  //   app.provide('pspdfkitlkey', config.pspdfkitlkeybopus);
  // } else {
  //   app.provide('pspdfkitlkey', config.pspdfkitlkeybopus);
  // }
  app.provide('imagesControl', new ImagesControl());
  app.use(store);
  // router.beforeEach((to, from, next) => {
  //   console.log('to', to);
  //   if (to.matched.length > 0) {
  //     next();
  //   } else {
  //     next(false);
  //   }
  // });
  app.use(router);
  app.use(HighchartsVue);
  app.use(VueHighlightJS);
  app.use(Vue3TouchEvents);
  console.log("All components added in main..")
  console.log("Attempting to set user..")
  app.provide('user', (localStorage.getItem('bOpus_user') !== null ? JSON.parse(localStorage.getItem('bOpus_user')) : null));
  console.log("User set..")
  console.log("Attempting to mount app..")
  app.mount('#app');

}).catch((error) => {
  console.log('The initial fetch in main failed \n', error);
});
